interface KaloError {
  response?: {
    data?: {
      errors?: {
        password: string[]
      }
      message: string
    }
  }
}

export function ErrorMessage(err: KaloError) {
  const passwordErrors: string[] = err.response?.data?.errors?.password ?? [
    err.response?.data?.message ?? '',
  ]
  return (
    <ul>
      {passwordErrors.map((msg, index) => (
        <li key={index}>{msg}</li>
      ))}
    </ul>
  )
}
